<div class="error-dialog">
  <h1 mat-dialog-title>Vous n'avez pas accès à cette application</h1>
  <mat-dialog-content>
    <img [src]="data.imageUrl" alt="Un gros chien méchant">
  </mat-dialog-content>
</div>
